/* VOLVR — Custom JS */

document.addEventListener('DOMContentLoaded', function () {

  /* --- Hero "Comment ca marche" -> scroll vers la section how_it_works --- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.btn-ghost-hero a, .btn-ghost-hero [class*="button"], [class*="btn-ghost-hero"]');
    if (!btn) return;
    e.preventDefault();
    var target =
      document.getElementById('how_it_works') ||
      document.getElementById('shopify-section-custom_section_b8KhGP');
    if (!target) return;
    var header = document.querySelector('sticky-header, .header, .header-wrapper, header');
    var offset = header ? header.getBoundingClientRect().height : 70;
    var y = target.getBoundingClientRect().top + window.pageYOffset - offset - 10;
    window.scrollTo({ top: y, behavior: 'smooth' });
  });

});
